const toolsFiles: {[key: string]: any} = {
  "engineer-offer-breakdown": {
    "title": "Engineer Offer Breakdown",
    "date": "2025-09-28T12:00:00-07:00",
    "file": "engineer-offer-breakdown.md",
    "slug": "engineer-offer-breakdown"
  }
}
export default toolsFiles;